import { faSortDown, faSortUp } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Field } from "formik";
import { get } from "lodash";
import React, { useState } from "react";
import {
  FieldInputDollar,
  FieldInputDollarBox,
  SearchComponent,
  WithDrawalCard,
  WithdrawalExpandableCard,
} from "../../../components";
import Table from "../../../components/CsplTable/CsplTable";
import {
  distributionFormFields,
  manageDistributionFormNames,
} from "../../../utils";
import {
  calculateGrossAmountFromNetAmountSourceWise,
  CalculateProrationForSourceAllocation,
  calculateRequestedAmountEffective,
  getFilteredRkData,
  getValues,
  GetWithdrawalAmountBasedOnStrategy,
  GetWithdrawalStrategy,
  WithdrawalStrategy,
} from "./DistributionConstantsAndFunctions";
const columns = [
  {
    label: "Investment Name",
    columnName: "investmentName",
    width: "20%",
  },
  {
    label: "Available Amount",
    columnName: "investmentAvailableAmount",
    width: "20%",
  },
  {
    label: "Nav",
    columnName: "nav",
    width: "10%",
  },
  {
    label: "Units",
    columnName: "units",
    width: "10%",
  },
  {
    label: "Gross withdrawal",
    columnName: "investmentGrossWithdrawalAmount",
    width: "20%",
  },
  {
    label: "Net withdrawal",
    columnName: "investmentNetWithdrawalAmount",
    width: "20%",
  },
];

const formName = manageDistributionFormNames.WITHDRAWAL_REQUEST;
const fields = distributionFormFields[formName];

function PeriodicPaymentSourceAllocationTableComponent(props) {
  const {
    values,
    setFieldValue,
    style = {},
    singleSourceBalance,
    filteredSourceBalances,
    proratedDataForSourceAllocation,
    handleChange,
    requestedAmountEffective,
    grossAmountEffective,
    availableBalanceMapForEachSourceInvestment,
    ...rest
  } = props;
  const sourceAvailableFromFilteredSourceBalances = availableBalanceMapForEachSourceInvestment.find(
    (_) => _.sourceId === singleSourceBalance.sourceId
  );
  console.log(
    "sourceAvailableFromFilteredSourceBalances",
    sourceAvailableFromFilteredSourceBalances,
    singleSourceBalance,
    grossAmountEffective,
    requestedAmountEffective
  );
  const sourceProrationFactor =
    sourceAvailableFromFilteredSourceBalances?.sourceEmployeeMap
      ?.sourceWithdrawalAmount /
    availableBalanceMapForEachSourceInvestment.reduce(
      (a, b) => a + b?.sourceEmployeeMap?.sourceWithdrawalAmount,
      0
    );
  const allocatedSourceWithdrawal =
    values[fields.allocatedSourceWithdrawal] ?? [];
  const sourceIndex = allocatedSourceWithdrawal.findIndex(
    (_) => _.sourceId === singleSourceBalance.sourceId
  );
  const fieldNameForSpecificSourceAllocation = `${fields.allocatedSourceWithdrawal}.${sourceIndex}.sourceEmployeeMap.sourceWithdrawalAmount`;
  const grossAmountWithdrawnFromSource =
    singleSourceBalance?.sourceEmployeeMap?.accountBalance;
  const netAmountWithdrawnFromSource =
    (requestedAmountEffective * grossAmountWithdrawnFromSource) /
    grossAmountEffective;

  const headerData = {
    sourceName: singleSourceBalance?.sourceName,
    availableAmount: (sourceAvailableFromFilteredSourceBalances?.sourceEmployeeMap?.sourceWithdrawalAmount).toFixed(
      2
    ),
    grossWithdrawal: grossAmountWithdrawnFromSource.toFixed(2),
    netWithdrawal: netAmountWithdrawnFromSource.toFixed(2),
    fieldNameForSpecificSourceAllocation: fieldNameForSpecificSourceAllocation,
  };
  const [isExpandable, setIsExpandable] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const filteredAllocatedInvestmentWithdrawals = get(
    singleSourceBalance,
    "sourceInvestmentBalances",
    []
  ).filter((_) =>
    (_.investmentName ?? "").toLowerCase().includes(searchTerm.toLowerCase())
  );
  console.log("singleSourceBalance", singleSourceBalance);

  return (
    <>
      <WithdrawalExpandableCard
        className="source-allocation-table-component"
        headerData={headerData}
        isExpandable={isExpandable}
        setIsExpandable={setIsExpandable}
        isCustomSource={false}
        style={style}
        values={values}
        setFieldValue={setFieldValue}
        handleChange={handleChange}
      >
        <div className="wd-expandable-children">
          <div className="p-2 withdrawalbackground">
            <SearchComponent
              onSearchChange={(value) => {
                setSearchTerm(value);
              }}
            />
            <span className="ft-12 withdrawalTextColor">
              {filteredAllocatedInvestmentWithdrawals.length} Records Found
            </span>
          </div>
          <div>
            <div className="header-tile pl-2 pr-2 w-100">
              {columns.map((_, ind) => (
                <div
                  style={{ width: _?.width }}
                  className="withdrawal-Text-Color d-flex"
                >
                  {_?.label}{" "}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginLeft: "8px",
                      marginTop: "-3px",
                    }}
                  >
                    {/* <div style={{ height: "7.5px", overflow: "visible" }}> */}
                    <FontAwesomeIcon
                      icon={faSortUp}
                      size="xs"
                      style={{ cursor: "pointer" }}
                      // onClick={() => {
                      //   let temp = investmentAllocationData
                      //     .sort((x) => x[_.columnName])
                      //     .reverse();
                      //   setInvestmentAllocationData(temp);
                      // }}
                    />
                    {/* </div> */}
                    <FontAwesomeIcon
                      icon={faSortDown}
                      size="xs"
                      style={{ cursor: "pointer" }}
                      // onClick={() => {
                      //   let temp = investmentAllocationData.sort(
                      //     (x) => x[_.columnName]
                      //   );
                      //   setInvestmentAllocationData(temp);
                      // }}
                    />
                  </div>
                </div>
              ))}
            </div>
            <Table className="source-allocation-table-component">
              <Table.Tbody>
                {filteredAllocatedInvestmentWithdrawals.map((_, ind) => {
                  return (
                    <Table.Tr
                      className={ind % 2 === 0 ? "grey-style" : "white-style"}
                    >
                      {columns.map((col, index) => {
                        if (col.columnName === "netWithdrawal") {
                          return (
                            <Table.Td style={{ width: col.width }}>
                              {<>{_[col.columnName]}</>}
                            </Table.Td>
                          );
                        }

                        let investmentFound = get(
                          sourceAvailableFromFilteredSourceBalances,
                          "sourceInvestmentBalances",
                          []
                        ).find((x) => x.investmentId === _.investmentId);
                        console.log("investmentFound", investmentFound);
                        investmentFound = investmentFound
                          ? investmentFound
                          : null;
                        const netWithdrawalAmount = getValues(
                          _?.sourceEmployeeInvestmentMap?.accountBalance
                        );
                        const availableAmountInvestment = getValues(
                          investmentFound?.sourceEmployeeInvestmentMap
                            ?.accountBalance
                        );
                        const grossWithdrawalAmount = getValues(
                          (netWithdrawalAmount *
                            grossAmountWithdrawnFromSource) /
                            netAmountWithdrawnFromSource
                        );
                        return (
                          <Table.Td style={{ width: col.width }}>
                            <div
                              style={{
                                whiteSpace: "nowrap",
                                paddingLeft: "10px",
                              }}
                            >
                              {col.columnName === "investmentAvailableAmount"
                                ? availableAmountInvestment.toFixed(2)
                                : col.columnName ===
                                  "investmentNetWithdrawalAmount"
                                ? netWithdrawalAmount.toFixed(2)
                                : col.columnName ===
                                  "investmentGrossWithdrawalAmount"
                                ? grossWithdrawalAmount.toFixed(2)
                                : _[col.columnName]}
                            </div>
                          </Table.Td>
                        );
                      })}
                    </Table.Tr>
                  );
                })}
              </Table.Tbody>
            </Table>
          </div>
        </div>
      </WithdrawalExpandableCard>
    </>
  );
}

function PeriodicPaymentSourceAllocation(props) {
  const {
    values,
    withdrawalTransactionForPeriodicPayment,
    sourceBalances,
    ...rest
  } = props;

  const filteredSourceBalances = getFilteredRkData(
    sourceBalances,
    false,
    values,
    withdrawalTransactionForPeriodicPayment,
    0
  );

  const availableBalanceMapForEachSourceInvestment = CalculateProrationForSourceAllocation(
    filteredSourceBalances,
    0,
    true
  );
  const requestedAmountEffective = calculateRequestedAmountEffective(
    values,
    {
      ...withdrawalTransactionForPeriodicPayment,
      [fields.grossAmount]:
        withdrawalTransactionForPeriodicPayment[fields.requestedAmount],
    },
    filteredSourceBalances
  );
  const grossAmountEffective = calculateGrossAmountFromNetAmountSourceWise(
    withdrawalTransactionForPeriodicPayment,
    values,
    filteredSourceBalances
  );
  const proratedDataForSourceAllocation = GetWithdrawalAmountBasedOnStrategy(
    GetWithdrawalStrategy(withdrawalTransactionForPeriodicPayment),
    filteredSourceBalances ?? [],
    withdrawalTransactionForPeriodicPayment?.sourceHierarchyDetails ?? [],
    grossAmountEffective ?? 0,
    []
  );

  const dataToMap = proratedDataForSourceAllocation;
  return (
    <div>
      {dataToMap && dataToMap.length <= 0 ? (
        <>
          <div className="slider-heading d-flex w-100 mb-2">Source details</div>
          <div className="ft-12 ">No Sources Available</div>
        </>
      ) : (
        <>
          <div className="slider-heading d-flex w-100 mb-2">Source details</div>

          <>
            <div className="mt-20">
              {dataToMap.map((singleSourceBalance) => {
                return (
                  <PeriodicPaymentSourceAllocationTableComponent
                    style={{ width: "1000px" }}
                    singleSourceBalance={singleSourceBalance}
                    filteredSourceBalances={filteredSourceBalances}
                    proratedDataForSourceAllocation={
                      proratedDataForSourceAllocation
                    }
                    grossAmountEffective={grossAmountEffective}
                    requestedAmountEffective={requestedAmountEffective}
                    availableBalanceMapForEachSourceInvestment={
                      availableBalanceMapForEachSourceInvestment
                    }
                    {...props}
                  />
                );
              })}{" "}
            </div>
          </>
          <WithDrawalCard
            cssStyle={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "20px",
              padding: "8px",
              width: "1000px",
            }}
            style={2}
          >
            <div className="heading-text2">Net Withdrawal Amount</div>
            <div className="heading-text2">
              $ {getValues(requestedAmountEffective).toFixed(2)}
            </div>
          </WithDrawalCard>
        </>
      )}
    </div>
  );
}

export default PeriodicPaymentSourceAllocation;
